var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDmEwalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 51,
    viewBox: "0 0 62 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.6339 29.5114C64.7591 43.3461 47.1097 45.9179 37.8944 45.4745C29.831 46.488 11.7509 46.7287 3.93788 39.5833C-5.82834 30.6516 3.63738 11.0778 20.6156 4.99664C37.5938 -1.08454 57.7274 12.218 61.6339 29.5114Z",
    fill: "#FBFBFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5916 11.3184H19.1457C17.9608 11.3184 17 12.3015 17 13.514V48.3042C17 49.5245 17.9696 50.4999 19.1457 50.4999H36.5916C37.7718 50.4999 38.7374 49.5206 38.7374 48.3042C38.7374 48.005 38.7374 15.8633 38.7374 13.514C38.7374 12.3015 37.7765 11.3184 36.5916 11.3184Z",
    fill: "url(#paint0_linear_8908_506)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6569 19.6165V43.319C19.6569 43.6577 19.925 43.9321 20.256 43.9321H35.4814C35.8123 43.9321 36.0808 43.6577 36.0808 43.319V19.6165H19.6569Z",
    fill: "#B0B6BD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4814 16.7366H20.256C19.9253 16.7366 19.6569 17.011 19.6569 17.3497V19.7785H36.0805V17.3497C36.0808 17.011 35.8123 16.7366 35.4814 16.7366Z",
    fill: "#4D5054"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.249 47.1788C29.249 47.959 28.6312 48.5913 27.8687 48.5913C27.1062 48.5913 26.4883 47.959 26.4883 47.1788C26.4883 46.3986 27.1062 45.7664 27.8687 45.7664C28.6312 45.7664 29.249 46.3986 29.249 47.1788Z",
    fill: "#4D5054"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4586 14.4888H26.279C25.96 14.4888 25.7012 14.2239 25.7012 13.8972C25.7012 13.5708 25.96 13.3059 26.279 13.3059H29.4586C29.7777 13.3059 30.0365 13.5708 30.0365 13.8972C30.0365 14.2239 29.7777 14.4888 29.4586 14.4888Z",
    fill: "#4D5054"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6741 22.2686C42.0253 22.2686 25.6559 22.2686 24.2026 22.2686C23.5879 22.2686 23.0848 22.783 23.0848 23.4123V24.1554C23.0848 24.7844 23.5879 25.2991 24.2026 25.2991H43.7921V23.4123C43.7921 22.783 43.2891 22.2686 42.6741 22.2686Z",
    fill: "#CA9114"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1833 22.9463C23.1205 23.0889 23.0848 23.2461 23.0848 23.412V24.1552C23.0848 24.7844 23.5879 25.2989 24.2026 25.2989H43.7921V23.6246H24.2026C23.7497 23.6246 23.3586 23.3448 23.1833 22.9463Z",
    fill: "#CA9114"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5956 34.3052C37.6902 34.3052 36.95 33.6816 36.95 32.7556C36.95 31.8292 37.6902 31.2056 38.5956 31.2056H43.7921V25.2096H24.2026C23.5879 25.2096 23.0848 24.6952 23.0848 24.0659V40.2979C23.0848 40.9271 23.5879 41.4419 24.2026 41.4419H42.6741C43.2891 41.4419 43.7921 40.9271 43.7921 40.2979V34.3055H38.5956V34.3052Z",
    fill: "url(#paint1_linear_8908_506)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2139 25.2096H24.2026C23.5879 25.2096 23.0848 24.6949 23.0848 24.0659V40.2979C23.0848 40.9271 23.5879 41.4419 24.2026 41.4419H25.2139V25.2096Z",
    fill: "#FDBC2E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2026 41.4419H24.8403C24.7056 41.253 24.6259 41.0213 24.6259 40.7708V25.2096H24.2026C23.5873 25.2096 23.0848 24.6946 23.0848 24.0659V40.2979C23.0848 40.9271 23.5879 41.4419 24.2026 41.4419Z",
    fill: "#FDBC2E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4374 31.0713H38.464C37.559 31.0713 36.8184 31.8291 36.8184 32.7555C36.8184 33.6816 37.559 34.4393 38.464 34.4393H44.4374C44.6392 34.4393 44.8031 34.2716 44.8031 34.0651V31.4456C44.8031 31.239 44.6392 31.0713 44.4374 31.0713Z",
    fill: "#CA9114"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38.359 32.7555C38.359 31.8291 39.0999 31.0713 40.0049 31.0713H38.4639C37.5586 31.0713 36.818 31.8291 36.818 32.7555C36.818 33.6816 37.5589 34.4393 38.4639 34.4393H40.0049C39.0999 34.4393 38.359 33.6816 38.359 32.7555Z",
    fill: "#FFEECA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1257 33.3469H38.5578C38.2385 33.3469 37.9799 33.0821 37.9799 32.7556C37.9799 32.4289 38.2385 32.1641 38.5578 32.1641H39.1257C39.4447 32.1641 39.7035 32.4289 39.7035 32.7556C39.7035 33.0821 39.4447 33.3469 39.1257 33.3469Z",
    fill: "#FFEECA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8908_506",
    x1: 27.8687,
    y1: 11.3184,
    x2: 27.8687,
    y2: 50.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A919A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666E78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8908_506",
    x1: 23.0848,
    y1: 25.2243,
    x2: 39.9629,
    y2: 47.0143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD375"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmEwalletIcon);
export default __webpack_public_path__ + "static/media/dm-ewallet-icon.485d0def1708f94b0cb6f2aea2153e6c.svg";
export { ForwardRef as ReactComponent };